import { DEFAULT_STATE } from '../constants'

export const initialQualityContentState = {
  quality: DEFAULT_STATE.quality,
  contentSource: DEFAULT_STATE.contentSource,
}
